// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picket-tk-iu {\n    width: 200px !important;\n}\n.markc-estatus-standard{\n    background: #fff;\n    color: black;\n}\n.markc-estatus-block{\n    background: steelblue;\n    color: white;\n}\n.markc-estatus-block-noaprobado{\n    background: rgb(44, 4, 4);\n    color: white;\n}\n.ant-table-row:hover{\n    color: black;\n}\n.tab-view-trassc{\n    width: 900px ;\n}\n.FromCloudOpciones,.ant-form-item-label label{\n    color:rgba(14, 13, 13, 0.85)  !important;\n}", ""]);
// Exports
module.exports = exports;
